module.exports = __webpack_public_path__ + "814252843561c6bc4bca50ce74d7b4d6.svg";